var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"fp-click-outside",rawName:"v-fp-click-outside",value:(_vm.close),expression:"close"}],staticClass:"fpui-dropdown",class:{ active: _vm.active }},[_vm._t("header"),_vm._t("options")],2)}
var staticRenderFns = []

export { render, staticRenderFns }